import { useState } from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

// import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
// import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
// import TimePicker from '@material-ui/lab/TimePicker';

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { AssignmentButtonWrapper, AssignmentInputButtonContainer, TableWrapper } from '../../../styles/assignment/assignment';
import { Link } from 'react-router-dom';
import { Table } from '../../../components/table/table';
import { SchoolData } from '../../../services/tableData';
import { CustomModal } from '../../../components/modal'
// import { RowDots } from "../../../components/table/row-menu";

const schema = yup.object().shape({
    schoolName: yup.string().required("School Name is a required field"),
    schoolCode: yup.string().required("School Code is a required field"),
    highestLevel: yup.string().required("Highest Class is a required field"),
    description: yup.string().required("Descriptipon is a required field"),
});


const AdminSchools = () => {

    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
        },
        {
            name: "Motto",
            selector: (row) => row.motto,
        },
        {
            name: "Highest Level",
            selector: (row) => row.highestLevel,
        },
        {
            name: "School Code",
            selector: (row) => row.schoolCode,
        },
    ];

    const [showModal, setShowModal] = useState(false);
    const [imageUploadValue, setImageUploadValue] = useState('')

    const {
        handleSubmit,
        register,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
        setShowModal(false)
    }

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }

    return (
        <>
            <CustomModal title="Add School" onClose={() => setShowModal(false)} showModal={showModal}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <p style={{ marginTop: '2.4rem', fontSize: '1.2rem', fontWeight: '700', color: '#969696', }}>*You can make bulk uploads my using the Bulk upload field</p>
                    <InputWrapper>
                        <Input
                            id="schoolName"
                            type="text"
                            placeholder="School Name"
                            {...register("schoolName")}
                            error={errors.schoolName?.message}
                            fullWidth
                        />

                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            id="schoolCode"
                            type="text"
                            placeholder="School Code"
                            {...register("schoolCode")}
                            error={errors.schoolCode?.message}
                            fullWidth
                        />

                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            id="highestLevel"
                            type="text"
                            placeholder="highest Class"
                            {...register("highestLevel")}
                            error={errors.highestLevel?.message}
                            fullWidth
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            id="description"
                            type="text"
                            placeholder="Description"
                            {...register("description")}
                            error={errors.description?.message}
                            fullWidth
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <AssignmentInputButtonContainer >
                            <Input value={imageUploadValue} fullWidth type='text' placeholder="Choose file" style={{ height: '42px' }} />

                            <label htmlFor="contained-button-file">
                                <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                <UploadButton variant="contained" component="span"
                                    disableElevation
                                    color="primary"
                                >
                                    BROWSE
                                </UploadButton>
                            </label>

                        </AssignmentInputButtonContainer>
                        <p style={{ marginTop: '1.6rem', fontSize: '1rem', color: '#969696', }}>*Uploaded file must be csv with the following headers; Name, Description, School Code, Highest Level etc.</p>
                    </InputWrapper>
                    <Button
                        type="submit"
                        style={{ marginLeft: 'auto', marginTop: '6rem' }}
                        responsive
                    >
                        ADD
                    </Button>
                </form>
            </CustomModal>

            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <MainContent>
                            <Heading>
                                Schools
                            </Heading>
                            <Breadcrumb
                                crumbs={['schools']}
                            />
                            <div style={{ marginTop: '3.7rem' }}>
                                <AssignmentButtonWrapper>
                                    <Button onClick={() => setShowModal(true)} size='small'>ADD SCHOOL</Button>
                                    <Button size='small' variant="secondary">Print</Button>
                                </AssignmentButtonWrapper>
                                <TableWrapper>
                                    <Table
                                        columns={columns}
                                        data={SchoolData || []}
                                    />
                                </TableWrapper>
                            </div>
                        </MainContent>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper >
        </>
    )
}

export default AdminSchools
